export const init = {
    mode: 'single-player',
    source: null,
    session: null,
    character: null,
    loadout: null,
    tree: null,
    division: null,
    difficulty: null,
    bout: 1,
    losses: 0,
    winner: null,
    outcome: null,
    log: [],
    rewards: [],
    milestone: null, // null | { character, division, difficulty } — set when a division is cleared at a new peak difficulty for the first time

    multiplayer: {},
    mmr_change: 0,
    adBuff: null, // null | { type: 'stamina' | 'strength' | 'expertise' | 'mastery' | 'toughness', value: 0.10 }
    adReady: false,
    adLoading: false,
    pendingAdUlid: null,
};
